import { UnitType } from '@exodus/currency'

const name = 'elrond'
const displayName = 'MultiversX'
const ticker = 'EGLD'
const displayTicker = 'EGLD'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#5974D7'
const gradientColors = ['#5974D7', '#1B46C2']
const gradientCoords = { x1: '100%', y1: '100%', x2: '0%', y2: '0%' }
const chainBadgeColors = gradientColors

const units = {
  base: 0,
  EGLD: 18,
}
const currency = UnitType.create(units)

const assetType = 'OTHER'

const keyDerivationAlgorithm = 'SLIP10'
const curve = 'ed25519'

const blockExplorer = {
  addressUrl: (accountId) =>
    `https://explorer.elrond.com/accounts/${encodeURIComponent(accountId)}`,
  txUrl: (txId) => `https://explorer.elrond.com/transactions/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Elrond is a highly scalable, fast and secure blockchain platform for distributed apps, enterprise use cases and the new internet economy.',
  reddit: 'https://www.reddit.com/r/elrondnetwork',
  twitter: 'https://twitter.com/elrondnetwork',
  website: 'https://elrond.com/',
  telegram: 'https://t.me/ElrondNetwork',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  curve,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  keyDerivationAlgorithm,
  name,
  primaryColor,
  properName: displayName, // deprecated
  properTicker: displayTicker, // deprecated
  ticker,
  toString: () => name,
  units,
}

export default [asset]
